module.exports = {
	"id": "NR",
	"name": "Nauru",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.03074,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.038425,
			"29": null,
			"30": 0.007685,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": 0.038425,
			"36": 0.01537,
			"37": null,
			"38": null,
			"39": null,
			"40": 0.007685,
			"41": 0.023055,
			"42": 0.038425,
			"43": null,
			"44": null,
			"45": null,
			"46": 0.023055,
			"47": null,
			"48": null,
			"49": 0.04611,
			"50": 0.16907,
			"51": 0.253605,
			"52": 0.13833,
			"53": 6.001985,
			"54": 2.41309,
			"55": null,
			"56": null,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.06148,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": 2.789655,
			"15": null,
			"16": 0.023055,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.04611,
			"22": 0.01537,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.007685,
			"29": null,
			"30": 1.56774,
			"31": null,
			"32": null,
			"33": 0.115275,
			"34": null,
			"35": null,
			"36": null,
			"37": null,
			"38": null,
			"39": null,
			"40": 0.053795,
			"41": null,
			"42": null,
			"43": 0.069165,
			"44": 0.03074,
			"45": 0.007685,
			"46": 0.01537,
			"47": 0.09222,
			"48": 0.32277,
			"49": 0.438045,
			"50": null,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": null
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.01537,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": null,
			"38": null,
			"39": null,
			"40": 0.12296,
			"41": null,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.04611
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": 0.023055,
			"10": 0.13833,
			"3.1": null,
			"3.2": null,
			"5.1": 0.04611,
			"6.1": null,
			"7.1": null,
			"9.1": 0.099905
		},
		"ios_saf": {
			"8": 0,
			"10": 0.232631477935,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.00626914914654,
			"8.1-8.4": 0.0115819874063,
			"9.0-9.2": 0.00552535179017,
			"9.3": 0.0842970337219
		},
		"android": {
			"3": 0,
			"4": 0.0536816795866,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00671020994832,
			"4.1": 0.19363748708,
			"4.2-4.3": 0.4840937177,
			"4.4": 1.11006044574,
			"4.4.3-4.4.4": 1.11964645995
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 2.359295,
			"9": 4.79544,
			"10": 1.90588,
			"11": 50.49045,
			"5.5": null
		},
		"op_mob": {
			"0": 0.114787288552,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00318853579311
		},
		"edge": {
			"12": 0.01537,
			"13": 0.90683,
			"14": 0.04611
		},
		"ie_mob": {
			"10": 0.0794273239437,
			"11": 0.323382676056
		},
		"bb": {
			"7": 0.00057875,
			"10": null
		},
		"samsung": {
			"0": 1.29177
		},
		"and_uc": {
			"0": 3.08821
		},
		"op_mini": {
			"0": 1.54650917565
		},
		"and_chr": {
			"0": 14.142995
		},
		"and_ff": {
			"0": 0.002315
		}
	},
	"total": 99.81372875
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/NR.json
 ** module id = 613
 ** module chunks = 0
 **/